var p = "16px",
  x = 160,
  o = 180,
  t = "35px",
  c = "320px",
  e = "640px",
  n = "960px",
  r = "1280px",
  s = "8px",
  a = "16px",
  b = "4px";
export { p as a, a as b, e as c, c as e, r as i, x as n, o, s as p, b as r, n as s, t };